enum Flags {
  AiAssistant = 'ssp.ai-assistant',
  CasesBilling = 'ssp.cases-billing',
  PublisherUpdatesConfigureColumns = 'ssp.publisher-update-configure-columns-button',
  PublisherUpdatesSavedFilters = 'ssp.pu-saved-filters',
  PublisherUpdatesContractualPublishers = 'ssp.pu-contractual-publishers',
  PublisherUpdatesRegionFilter = 'ssp.pu-region-filter',
  PublisherUpdatesAskExpert = 'ssp.pu-ask-expert',
  PublisherUpdatesImpactFields = 'ssp.pu-impact-fields',
  PublisherDetailsTabMyContracts = 'ssp.pu-details-tab-my-contracts',
  PublisherDetailsTabMyContractsCompanyColumn = 'ssp.pu-details-tab-my-contracts-company-column',
  CaseEntitlements = 'spp.case-entitlements',
  CaseConfigItems = 'ssp.cases.config-items',
  UrlMigrationBanner = 'ssp.url-migration-banner',
  ShowSubCategory = 'spp.show-subcategory',
  NotificationSettingsMyContractPublishers = 'ssp.notification-settings-my-contract-publishers',
  RequestsCatalog = 'ssp.requests-catalog',
}

export default Flags;
